import { Outlet } from 'react-router-dom';

import {
  RecordingsSearchProvider,
  RefreshTokenProvider,
  SalesforceProvider,
  TwilioDeviceProvider,
} from '.';

export const RootProvider = () => {
  return (
    <RecordingsSearchProvider>
      <RefreshTokenProvider>
        <TwilioDeviceProvider>
          <SalesforceProvider>
            <Outlet />
          </SalesforceProvider>
        </TwilioDeviceProvider>
      </RefreshTokenProvider>
    </RecordingsSearchProvider>
  );
};
